import { hexToRgbArray, rgbaToPdfColor } from '../utils/color';
import { fabricToPdfCoords } from '../utils/coordinateUtils';

/**
 * Convert Fabric Rect to PDF Square annotation
 */
export function fabricRectToPdfSquare({
  page,
  fabricObject,
  basePageDimensions: { width, height },
  user_full_name,
}) {
  const {
    left,
    top,
    width: rectWidth,
    height: rectHeight,
    scaleX = 1,
    scaleY = 1,
    strokeWidth,
    stroke,
    fill,
  } = fabricObject;

  const x1 = left;
  const y1 = top;
  const x2 = left + rectWidth * scaleX;
  const y2 = top + rectHeight * scaleY;

  const pdfCoords = fabricToPdfCoords({
    x1,
    y1,
    x2,
    y2,
    page,
    width,
    height,
  });

  page.node.addAnnot(
    page.doc.context.obj({
      Type: 'Annot',
      Subtype: 'Square',
      Rect: pdfCoords.rect,

      C: hexToRgbArray(stroke),

      BS: { W: strokeWidth },

      T: user_full_name,
    })
  );
}
